<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="refreshPage()">
        <i class="material-icons">refresh</i>
      </div>
      <div *ngIf="filtersApplied" class="ir-btn th-btn-search" (click)="resetFilters()">
        <i class="material-icons">filter_alt_off</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="exportInspections()">
        <i class="material-icons">file_download</i>
      </div>
    </div>
    <div class="ir-line-content">
      <span
        >{{ inspectionsLabel | translate }} <strong>({{ inspections?.length }})</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div *ngIf="filtersApplied" class="ir-btn th-btn-search" (click)="resetFilters()">
        <i class="material-icons">filter_alt_off</i>
      </div>
      <div class="ir-btn th-btn-search" (click)="openFilters()">
        <i class="material-icons">tune</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="filter.searchText"
        focus="showSearch"
      />
    </div>
  </div>
</div>

<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <div class="ir-section--list th-section--admin">
    <div class="ir-line ir-line-title">
      <div class="ir-line--right">
        <button
          class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right"
          (click)="newInspectionFromModel()"
        >
          <span>{{ newInspectionLabel | translate }}</span>
        </button>
      </div>
      <div class="ir-line-content">
        <span>{{ 'inspections.inspections' | translate }}</span>
      </div>
    </div>
    <ng-container *ngIf="!isIntallation; else installationList">
      <manager-inspection-list-table
        [inspections]="inspections"
        [orderBy]="filter.order"
        (toggleSort)="sort($event)"
        (toggleScroll)="loadNextPage()"
        (toggleSelectInspection)="openInspection($event)"
        (toggleReport)="viewReport($event)"
      ></manager-inspection-list-table>
    </ng-container>
    <ng-template #installationList>
      <manager-installation-list-table
        [inspections]="inspections"
        [orderBy]="filter.order"
        (toggleSort)="sort($event)"
        (toggleScroll)="loadNextPage()"
        (toggleSelectInspection)="openInspection($event)"
        (toggleReport)="viewReport($event)"
      >
      </manager-installation-list-table>
    </ng-template>
  </div>
</div>

<modal (modalOutput)="applyFilters()" #filterModal></modal>
